import React__default, { useState, useEffect } from 'react';
import SubSelect from './SubSelect.js';
import SelectItem from './SelectItem.js';
import useSelectContext, { SelectContextProvider } from './SelectContext.js';
import '../../utils/index.js';
import useTranslation from '../../utils/Translation/useTranslation.js';

const SelectedItems = () => {
  const selectContext = useSelectContext();
  const {
    selectedSelectItems,
    enabledSelectItems
  } = selectContext;
  const [displayedItems, setDisplayedItems] = useState(selectedSelectItems);
  const [open, setOpen] = useState(false);
  const {
    translate
  } = useTranslation();
  useEffect(() => {
    if (open) {
      setDisplayedItems(selectedSelectItems);
    }
    // Display items should only update on open
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return /*#__PURE__*/React__default.createElement(SelectContextProvider, {
    value: {
      ...selectContext,
      isSelectedItems: true
    }
  }, /*#__PURE__*/React__default.createElement(SubSelect, {
    onIsOpenChange: setOpen,
    label: translate('selectedItems')
  }, Array.from(displayedItems, _ref => {
    let [value, label] = _ref;
    return /*#__PURE__*/React__default.createElement(SelectItem, {
      label: label,
      key: value,
      value: value,
      isDisabled: !enabledSelectItems.has(value)
    });
  })));
};

export { SelectedItems as default };
